import { render, staticRenderFns } from "./manualsev.vue?vue&type=template&id=bca4e654&scoped=true&"
import script from "./manualsev.vue?vue&type=script&lang=js&"
export * from "./manualsev.vue?vue&type=script&lang=js&"
import style0 from "./manualsev.vue?vue&type=style&index=0&id=bca4e654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca4e654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca4e654')) {
      api.createRecord('bca4e654', component.options)
    } else {
      api.reload('bca4e654', component.options)
    }
    module.hot.accept("./manualsev.vue?vue&type=template&id=bca4e654&scoped=true&", function () {
      api.rerender('bca4e654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/manualsev.vue"
export default component.exports